import dithering from './bayer.frag.ts'

export default /* glsl */ `${dithering}
uniform float uTime;
uniform sampler2D uDitheringTexture;
uniform vec2 uResolution;
uniform vec3 uProgress;

void main(){
  float threshold = 0.5 + 0.5 * sin((uTime + uProgress.x * 20.0) * 0.15);
  float range = 0.5;

  vec2 st = floor(gl_FragCoord.xy / 4.0);

  vec2 uv = st / (uResolution / 4.0);
  uv -= 0.5;
  uv.x *= uResolution.x / uResolution.y;
  uv += 0.5;
  float wave = smoothstep(threshold - range, threshold + range, length(uv - vec2(0.5)));

  float dithering = texture2D(uDitheringTexture, st / 8.0).r;
  wave = step(dithering + 0.01, wave);

  gl_FragColor = vec4(wave, dithering, 0.0, 1.0);
}
`
